module.exports = __webpack_public_path__ + "img/icon-orchid.23274373.svg";